module.exports = __webpack_public_path__ + "img/mini-waiting.88a2d70e.svg";